import { BaseBepsService } from "../base/baseApiBeps";

export class BepsService extends BaseBepsService {
  async getBeps() {
    try {
      const { data } = await this.axiosClient.get('beps/obtenerBeps');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getBeps with stack: ${error}`);
    }
  }
  async getBepByDocument(document: string) {
    try {      
      const { data } = await this.axiosClient.get(`beps/obtenerBepsDocumento/${document}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getBepByDocument with stack: ${error}`);
    }
  }

  async postBeps(beps: any) {
    try {
      const { data } = await this.axiosClient.post('beps/guardarBeps', beps);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postBeps with stack: ${error}`);
    }
  }

  async putBepsByDocument(beps: any, numero_documento: string) {
    try {
      const { data } = await this.axiosClient.put(`beps/actualizarBeps/${numero_documento}`, beps);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in putBepsByDocument with stack: ${error}`);
    }
  }

  //Postulaciones
  async guardarPostulacionBeps(values: any) {
    try {
      const { data } = await this.axiosClient.post('/postulaciones/', values);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerPostulacionesBeps with stack: ${error}`);
    }
  }
  

  async guardarDocumentosAdministrativosPostulacionBeps(id_postulacion: any, documentos_administrativos: any) {
    try {
      const { data } = await this.axiosClient.put(`postulaciones/guardarDocumentos/${id_postulacion}`,
        documentos_administrativos
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerPostulacionesBeps with stack: ${error}`);
    }
  }

  async actualizarEstadoPostulacion(id_postulacion: any, estado: string) {
    try {
      const { data } = await this.axiosClient.put(`postulaciones/actualizarEstadoPostulacion/${id_postulacion}`,
        estado
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerPostulacionesBeps with stack: ${error}`);
    }
  }

  async gernerarReporte(estadoDatos: string, fecha_inicio: string, fecha_fin: string) {
    try {
      const { data }  = await this.axiosClient.post('beps/report', 
      {estado: estadoDatos, fecha_inicio, fecha_fin},
      {
          responseType: "blob",
        }
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerPostulacionesBeps with stack: ${error}`);
    }
  }

}

export default new BepsService();
